import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-card-resultado-cotacao',
  templateUrl: './card-resultado-cotacao.component.html',
  styleUrls: ['./card-resultado-cotacao.component.scss'],
})
export class CardResultadoCotacaoComponent implements OnInit {
  @Input() abrangencia!: string;
  @Input() descricao!: string;
  @Input() numeroRegistro!: string;
  @Input() valor!: number;
  @Input() id!: string;
  @Input() idPessoa!: string;
  @Input() idProfissao!: string;
  @Input() acomodacao!: string;
  @Input() ehSaude: boolean = false;

  @Output() comprar = new EventEmitter<void>();
  constructor() {}

  onComprar() {
    this.comprar.emit();
  }

  ngOnInit(): void {}
}
